import React from 'react';
import { Tooltip, Button, Icon } from 'antd';

function RenderTooltipEdit({disabled, handleOnClick}) {
  return (
    <Tooltip title="Edit">
      <Button disabled={disabled} size="small" key="edit" onClick={handleOnClick}>
        <Icon type="form" />
      </Button>
    </Tooltip>
  );
}

export default RenderTooltipEdit;
